let Vuex = require('../../../../legacy/node_modules/vuex');
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        view: 'map',
        loading: false,
        button_visibility: false,
        page_title: '',
        search_type: 'quartos',
        city: null,
        state: null,
        ads: [],
        sponsored_ads: [],
        pagination: {},
        selected_districts: [],
        districts: [],
        sort: 'relevant',
        amenities: [],
        rules: [],
        ad_types: [],
        property_types: [],
        filter: {
            ad_type: [],
            property_type: [],
            gender: '',
            price_range: [0, 15000],
            rules: [],
            amenities: [],
            bedrooms: [],
            bathrooms: [],
        },
        bounds: {
            minLat: null,
            minLng: null,
            maxLat: null,
            maxLng: null,
        },
    },
    getters: {
        getView: function (state) {
            return state.view;
        },
        getPageTitle: function (state) {
            return state.page_title;
        },
        getButtonVisibility: function (state) {
            return state.button_visibility;
        },
        getSearchType: function (state) {
            return state.search_type;
        },
        getAdTypes: function (state) {
            return state.ad_types;
        },
        getPropertyTypes: function (state) {
            return state.property_types;
        },
        getCity: function (state) {
            return state.city;
        },
        getState: function (state) {
            return state.state;
        },
        getCityName: function (state) {
            if (state.city === null) {
                return '';
            }

            return state.city.name + ' - ' + state.state.initials;
        },
        getCitySlug: function (state) {
            if (state.city === null) {
                return '';
            }

            return state.city.slug + '-' + state.state.initials.toLowerCase();
        },
        getFilter(state) {
            return state.filter;
        },
        getAds: function (state) {
            return state.ads;
        },
        getSponsoredAds: function (state) {
            return state.sponsored_ads;
        },
        getPagination: function (state) {
            return state.pagination;
        },
        getCurrentPage: function (state) {
            return state.pagination.current_page;
        },
        getSort: function (state) {
            return state.sort;
        },
        getAmenities: function (state) {
            return state.amenities;
        },
        getSelectedDistricts: function (state) {
            return state.selected_districts;
        },
        getDistricts: function (state) {
            return state.districts;
        },
        getSelectedTypeSlug: function (state) {
            let prop_slug = state.property_types.find(obj => {
                return obj.id == state.filter.property_type[0]
            })?.slug;

            let ad_slug = state.ad_types.find(obj => {
                return obj.id == state.filter.ad_type[0]
            })?.slug;

            return prop_slug ?? ad_slug ?? state.search_type;
        },
        getRules: function (state) {
            return state.rules;
        },
        getCoords(state) {
            if (state.city == null) {
                return { lat: null, lng: null };
            } else {
                return { lat: parseFloat(state.city.lat), lng: parseFloat(state.city.lng) };
            }
        },
        getActiveFilters: function(state) {
            const filters = state.filter;

            // Only include filters that have values
            const activeFilters = {};
            Object.entries(filters).forEach(([key, value]) => {
                if (Array.isArray(value) && value.length > 0) {
                    if (key === 'price_range') {
                        // Only include price range if it's not the default [0, 15000]
                        if (value[0] !== 0 || value[1] !== 15000) {
                            activeFilters[key] = value;
                        }
                    } else {
                        activeFilters[key] = value;
                    }
                } else if (typeof value === 'boolean' && value === true) {
                    // For boolean filters, only include if true
                    activeFilters[key] = value;
                } else if (typeof value === 'string' && value !== '') {
                    // For string filters, only include if not empty
                    activeFilters[key] = value;
                }
            });

            if (state.pagination.current_page != 1) {
                activeFilters.page = state.pagination.current_page;
            }

            return activeFilters;
        }
    },
    mutations: {
        setView: function (state, view) {
            state.view = view;
        },
        setLoading: function (state, loading) {
            state.loading = loading;
        },
        setPageTitle: function (state, title) {
            state.page_title = title;
        },
        setButtonVisibility: function (state, visibility) {
            state.button_visibility = visibility;
        },
        setCityName: function (state, city) {
            state.city_name = city;
        },
        setAds: function (state, ads) {
            state.ads = ads;
        },
        setSponsoredAds: function (state, ads) {
            state.sponsored_ads = ads;
        },
        setSearchType: function (state, type) {
            state.search_type = type;
        },
        setFilter(state, obj) {
            for (const key in obj) {
                if (state.filter.hasOwnProperty(key)) {
                    let value = obj[key];
                    if (Array.isArray(value) && value.length == 1) {
                        if (isNaN(value[0]))
                            value = value[0].split(',');
                    }
                    if (value == null)
                        continue;
                    Vue.set(state.filter, key, value);
                }
            }
        },
        removeFromFilter(state, obj) {
            for (const key in obj) {
                state.filter[key] = state.filter[key].filter(id => id != obj[key]);
            }
        },
        setCity: function (state, city) {
            state.city = city;
        },
        setState: function (state, model) {
            state.state = model;
        },
        setBounds: function (state, bounds) {
            state.bounds = bounds;
        },
        setSelectedDistricts: function (state, districts) {
            if (!Array.isArray(districts)) {
                if (districts.includes(','))
                    districts = districts.split(',');
                else if (districts.includes('|'))
                    districts = districts.split('|');
                else if (districts.length > 0)
                    districts = [districts];
                else
                    districts = [];
            }
            state.selected_districts = districts;
        },
        setPage: function(state, num) {
            state.pagination.current_page = num;
        },
        setPagination: function (state, obj) {
            state.pagination = obj;
        },
        setSort: function (state, sort) {
            state.sort = sort;
        },
        setAmenities: function (state, amenities) {
            state.amenities = amenities;
        },
        setDistricts: function (state, districts) {
            state.districts = districts;
        },
        setAdTypes: function (state, ad_types) {
            state.ad_types = ad_types;
        },
        setPropertyTypes: function (state, property_types) {
            state.property_types = property_types;
        },
        setRules: function (state, rules) {
            state.rules = rules;
        }
    },
    actions: {
        replaceUrl(context) {
            let activeFilters = context.getters.getActiveFilters;

            let url = `/busca/${context.getters.getSelectedTypeSlug}`;
            if (context.state.view == 'map') {
                url = `/busca-mapa/${context.getters.getSelectedTypeSlug}`;
            }

            if (context.getters.getCitySlug) {
                url += `/${context.getters.getCitySlug}`;
            }
            const districts = context.getters.getSelectedDistricts;
            if (districts && districts.length) {
                url += `/${districts.join(',')}`;
            }

            let urlFilters = { ...activeFilters };

            if (context.state.view == 'map') {
                // Doesn't specify page on url for map view since pagination shouldn't be applied in case the page is refreshed
                delete urlFilters.page;
            }

            const query = urlUtils.methods.getUrlQuery(urlFilters, true);
            if (query) {
                url += `?${query}`;
            }

            window.history.replaceState({}, '', url);
        },
        filterResults(context, append = false) {
            const payload = {
                bounds: context.state.bounds,
                district: context.state.selected_districts.join(','),
                type: context.state.search_type
            };

            if (context.state.city) {
                const city = context.state.city;

                payload.city = {
                  id: city.id,
                  lat: city.lat,
                  lng: city.lng,
                };
            }

            Object.assign(payload, context.getters.getActiveFilters);

            context.commit('setLoading', true);
            context.commit('setPagination', {});

            if (append === false) {
                context.commit("setAds", []);
            }

            return axios.post('/busca/filter', payload).then(({ data: { data, meta }, status }) => {
                if (status === 200) {
                    // Filter out duplicates when appending
                    const existingIds = context.state.ads.map(ad => ad.id);
                    const newAds = data.filter(ad => !existingIds.includes(ad.id));

                    context.commit('setAds', [...context.state.ads, ...newAds]);
                    context.commit('setPagination', meta);

                    context.commit('setButtonVisibility', data.length == meta.per_page);
                }

                return {
                    data: {
                        data,
                        meta
                    },
                    status
                }
            }).catch((err) => {
                return err;
            }).finally(() => {
                context.commit('setLoading', false);
            });
        },
        getFiltersData(context) {
            return axios.get('/search/filters-data/' + context.state.search_type + '/' + context.getters.getCitySlug).then((response) => {
                context.commit('setAdTypes', response.data.ad_types);
                context.commit('setPropertyTypes', response.data.property_types);
                context.commit('setAmenities', response.data.amenities);
                context.commit('setDistricts', response.data.districts);
                context.commit('setRules', response.data.rules);
            });
        }
    }
});

let urlUtils = require('./../components/mixins/url-params.js');
Vue.component('search', require('./../components/search/search.vue').default);
Vue.component('search-map', require('./../components/search/search-map.vue').default);

window.vm = new Vue({
    store,
    el: '#app',
});
